<template lang="pug">
  div.timetrade-button(v-if='nonExclusiveTier || eligibleUser')
    a.btn(v-text='text' :href='"#modal-" + _uid' data-toggle='modal' v-if='!isFull && isWeb' class='timetrade-btn' @click='showTimeTradeModal(true)')
    a.btn(v-text='text' :target='isMobileApp ? undefined : "_blank"' :href='url' v-else-if='!isFull && !isWeb' class='timetrade-btn')

    .modal.fade(aria-hidden='true' role='dialog' tabindex='-1' :id='"modal-" + _uid' data-keyboard='false' data-backdrop='static' v-if='!isFull && isWeb')
      .modal-dialog.modal-lg(role='document')
        .modal-content
          .modal-header
            .modal-title
            button.close(type='button' data-dismiss='modal' aria-label='Close' @click='showTimeTradeModal(false)')
          .modal-body
            iframe(frameborder='0' allow='geolocation *' :src='url' v-if='isModalActive')
  div.timetrade-button(v-else)
    a.btn(v-text='text' :href='"#modal-" + _uid' data-toggle='modal' class='timetrade-btn')

    .modal.fade(aria-hidden='true' role='dialog' tabindex='-1' :id='"modal-" + _uid' data-keyboard='false' data-backdrop='static')
      .modal-dialog.modal-sm(role='document')
        .modal-content
          .modal-header
            .modal-title
            button.close(type='button' data-dismiss='modal' aria-label='Close')
          .modal-body
            .exclusivity-title(v-t='"bookingService.exclusivityTitle"')
            .exclusivity-description(v-text='exclusivityDescription' v-if='loyaltyTiers')
            a.btn.sign-in(:href='signInPath()' v-text='$t("account.user.signIn")' v-if='!currentUser')
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "isFullText": "This %{type} is full. Browse other classes, services and events at this store",
      "exclusivityTitle": "Sorry!",
      "exclusivityAllTier": "This is exclusive to only members!",
      "exclusivityMessageOneTier": "This is exclusive to %{tier} members only!",
      "exclusivityMessageTwoTier": "This is exclusive to %{tiers} members."
    }
  },
  "lng_zh": {
    "bookingService": {
      "isFullText": "This %{type} is full. Browse other classes, services and events at this store",
      "exclusivityTitle": "很抱歉!",
      "exclusivityAllTier": "只適用於會員！",
      "exclusivityMessageOneTier": "只適用於%{tier}卡會員！",
      "exclusivityMessageTwoTier": "只適用於%{tiers}卡會員。"
    }
  },
  "lng_th": {
    "bookingService": {
      "isFullText": "This %{type} is full. Browse other classes, services and events at this store",
      "exclusivityTitle": "ขออภัย!",
      "exclusivityAllTier": "This is exclusive to only memebers!",
      "exclusivityMessageOneTier": "This is exclusive to %{tier} members only!",
      "exclusivityMessageTwoTier": "This is exclusive to %{tiers} members."
    }
  },
  "lng_id": {
    "bookingService": {
      "isFullText": "This %{type} is full. Browse other classes, services and events at this store",
      "exclusivityTitle": "MAAF!",
      "exclusivityAllTier": "This is exclusive to only memebers!",
      "exclusivityMessageOneTier": "This is exclusive to %{tier} members only!",
      "exclusivityMessageTwoTier": "This is exclusive to %{tiers} members."
    }
  },
  "lng_ko": {
    "bookingService": {
      "isFullText": "이 %{type}은/는 마감되었습니다. 이 매장의 다른 클래스, 서비스 및 이벤트를 찾아보세요",
      "exclusivityTitle": "죄송합니다.",
      "exclusivityAllTier": "This is exclusive to only memebers!",
      "exclusivityMessageOneTier": "This is exclusive to %{tier} members only!",
      "exclusivityMessageTwoTier": "This is exclusive to %{tiers} members."
    }
  }
}
</i18n>

<script>
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { loadTimetradeIFrame } from '@/modules/services/remote-resources'
import { timetrade, serviceProviders } from '@/modules/config/booking-services'
import { sessionUtil } from '@/mixins/pathUtil'
import { mapGetters } from 'vuex'

export default {
  name: 'TimetradeButton',
  mixins: [
    sessionUtil
  ],
  props: ['text', 'query', 'activity', 'store', 'category', 'loyaltyTiers'],
  data () {
    return {
      isModalActive: false
    }
  },
  computed: {
    ...mapGetters('bookingService', ['timetradeWorkflowUrl', 'hasVacancy']),
    ...mapGetters(['isWeb', 'isMobileApp']),
    currentUser: () => get(vueSupport, 'currentUser.data'),
    isFull () {
      return false
    },
    isMobile () {
      return vueSupport.isMobile
    },
    nonExclusiveTier () {
      return isEmpty(this.loyaltyTiers)
    },
    eligibleUser () {
      if (this.currentUser && this.loyaltyTiers[0] === 'All Tier') {
        return true
      }
      return this.currentUser && this.loyaltyTiers.includes(this.currentUser.attributes['loyalty-tier'].toLowerCase().replace(/^./, str => str.toUpperCase()))
    },
    exclusivityDescription () {
      const { loyaltyTiers } = this
      if (loyaltyTiers.includes('All Tier') || loyaltyTiers.length === 3) {
        return this.$t('bookingService.exclusivityAllTier')
      }

      const formattedTiers = loyaltyTiers.map(tier =>
        tier.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('')
      )

      if (loyaltyTiers.length === 1) {
        return this.$t('bookingService.exclusivityMessageOneTier', { tier: formattedTiers[0] })
      }

      if (loyaltyTiers.length === 2) {
        return this.$t('bookingService.exclusivityMessageTwoTier', { tiers: formattedTiers.join(' and ') })
      }

      return null
    },
    isFullText () {
      const type = this.activity.type
      return this.$t(`bookingService.isFullText`, { type: this.singularize(type) })
    },
    workFlow () {
      let wf
      if (this.category) {
        wf = serviceProviders.sephora

        if (this.activity && !isEmpty(this.activity.attributes['timetrade-workflow'])) {
          wf = this.activity.attributes['timetrade-workflow']
        } else if (!isEmpty(this.category.attributes['timetrade-workflow'])) {
          wf = this.category.attributes['timetrade-workflow']
        }
      } else {
        if (this.activity.attributes['special-event']) {
          wf = serviceProviders.specialevents
        } else {
          wf = serviceProviders.events
        }
      }
      return wf
    },
    url () {
      let query = this.query ? this.query : {}
      query = Object.assign(query, {
        wf: this.workFlow
      })

      if (this.currentUser) {
        query = Object.assign(query, {
          attendee_person_firstName: this.currentUser.attributes['first-name'],
          attendee_person_lastName: this.currentUser.attributes['last-name'],
          attendee_email: this.currentUser.attributes['email'],
          attendee_customField0: this.currentUser.attributes['mobile-phone']
        })
      }

      if (this.category) {
        if (this.category.attributes['timetrade-appointment-type-group-id']) {
          query = Object.assign(query, {
            appointmentTypeGroupId: this.category.attributes['timetrade-appointment-type-group-id']
          })
        }
        if (!timetrade.showAllStores && this.category.attributes['timetrade-location-group-id']) {
          query = Object.assign(query, {
            locationGroupId: this.category.attributes['timetrade-location-group-id']
          })
        }
      } else {
        query = Object.assign(query, {
          customer: serviceProviders.sephoraec
        })
      }

      if (this.workFlow === serviceProviders.virtualappointments) {
        query = Object.assign(query, {
          locationId: serviceProviders.virtualappointmentslocationid
        })
      } else if (this.activity && this.activity.attributes['special-event']) {
        query = Object.assign(query, {
          locationId: serviceProviders.specialeventlocationid
        })
      } else if (this.store) {
        query = Object.assign(query, {
          locationId: this.store.attributes['timetrade-location-id']
        })
      }
      return this.timetradeWorkflowUrl(query)
    }
  },
  created () {
    loadTimetradeIFrame()
  },
  methods: {
    showTimeTradeModal (boolean) {
      this.isModalActive = boolean
    },
    singularize (word) {
      switch (word) {
        case 'events':
          return 'event'
        case 'services':
          return 'service'
        case 'beauty_classes':
          return 'beauty class'
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .is-full {
    color: $brand-primary;
  }

  iframe {
    width: 100%;
    border: 0;
    min-height: 700px;

    @include media-breakpoint-down(sm) {
      min-height: 600px;
    }
  }

  .btn {
    max-width: 200px;
    width: 100%;

    @include media-breakpoint-down(tn) {
      max-width: none;
      margin-bottom: 10px;
      font-size: 95%;
    }
  }

  @include media-breakpoint-down(md) {
    .timetrade-btn {
      width: 160px;
    }
  }

  .modal-sm {
    min-width: 380px;

    @include media-breakpoint-down(xs) {
      min-width: 300px;
    }

    .modal-content {
      min-height: 260px;
    }

    .modal-body {
      position: absolute;
      top: 45%;
      text-align: center;
      transform: translateY(-45%);
    }

    .exclusivity-title {
      margin-top: 15px;
      @include font-sephora-serif-italic;
      font-size: 36px;
      text-transform: uppercase;
    }

    .exclusivity-description {
      width: 340px;
      margin-top: 30px;
      @include font-weight-bold;
      font-size: 16px;
      font-weight: 300;
      text-transform: uppercase;

      @include media-breakpoint-down(xs) {
        width: 320px;
      }
    }

    .sign-in {
      height: 40px;
      width: 200px;
      margin-top: 25px;
    }
  }
</style>
